export default __webpack_public_path__ + "static/media/breakfast.5493616e.png";